import type { RefObject } from "react"
import { useEffect } from "react"

// Linear's repeat-toast pump (swell, hold, settle), cut from its 800ms to 400ms by shortening the settle.
export const TOAST_PUMP_KEYFRAMES: Keyframe[] = [
	{ transform: "scale(1)", easing: "ease-out" },
	{ transform: "scale(1.05)", offset: 0.25 },
	{ transform: "scale(1.05)", offset: 0.375, easing: "ease-in-out" },
	{ transform: "scale(1)" },
]

export const TOAST_PUMP_DURATION_MS = 400

/** Pumps the element each time `pumpCount` goes up; 0 never pumps. */
export function useToastPump(
	ref: RefObject<HTMLElement | null>,
	pumpCount: number,
) {
	useEffect(() => {
		const element = ref.current
		if (!pumpCount || typeof element?.animate !== "function") return
		if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
		const animation = element.animate(TOAST_PUMP_KEYFRAMES, {
			duration: TOAST_PUMP_DURATION_MS,
		})
		return () => animation.cancel()
	}, [ref, pumpCount])
}
